import React, { lazy } from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';

const AssetTypeLayout = lazy(
  () => import('./asset-list/asset-type-layout/asset-type-layout'),
);

const AssetProfileLayout = lazy(
  () => import('./asset-profile/asset-profile-layout/asset-profile-layout'),
);

const AssetListPage = lazy(() => import('./asset-list/asset-list.page'));

const AssetDetailsPage = lazy(
  () => import('./asset-profile/asset-details/asset-details.page'),
);
const AssetInstancesPage = lazy(
  () => import('./asset-profile/asset-instances/asset-instances.page'),
);
const AssetRelatedScansPage = lazy(
  () => import('./asset-profile/asset-related-scans/asset-related-scans.page'),
);

export const AssetsRoutes = () => {
  const [fullMockedFF] = useFeatureFlag('ADS_FULL_MOCKED');

  return (
    <Routes>
      <Route path=":assetType?" element={<AssetTypeLayout />}>
        <Route index element={<AssetListPage />} />
      </Route>

      <Route path=":assetType/:assetId" element={<AssetProfileLayout />}>
        <Route index path="details?" element={<AssetDetailsPage />} />

        {fullMockedFF && (
          <>
            <Route path="instances" element={<AssetInstancesPage />} />
            <Route path="scans" element={<AssetRelatedScansPage />} />
          </>
        )}

        <Route path="*" element={<Navigate to="../" replace />} />
      </Route>
    </Routes>
  );
};
